<miq-textarea
  [(currentValue)]="value"
  [required]="configuration.required"
  [disabled]="configuration.isDisabled"
></miq-textarea>
